/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Api
 * API specification
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AvailableFiscalYears,
  BudgetPreview,
  BvaComparison,
  BvaTransactionEvidence,
  CertifiedActualsMonthlyResponse,
  ErrorResponse,
  FiscalYear,
  FiscalYearImport,
  FiscalYearImportInput,
  ForecastAccrualInput,
  ForecastAccrualRetirement,
  ForecastAuditResponse,
  ForecastCommitmentInput,
  ForecastCompletion,
  ForecastDecisionUpdate,
  ForecastInputList,
  ForecastInputOverlap,
  ForecastInputRecord,
  ForecastInputStatusChange,
  ForecastInputUpdate,
  ForecastLineUpdate,
  ForecastLineUpdateResult,
  ForecastOutlook,
  ForecastPlannedSpendInput,
  ForecastRefreshInput,
  ForecastRunInput,
  GetAvailableFiscalYearsParams,
  GetBvaComparisonParams,
  GetBvaTransactionEvidenceParams,
  GetCertifiedActualsMonthlyParams,
  GetCurrentForecastParams,
  GetFiscalYearBudgetPreviewParams,
  GetFiscalYearParams,
  GetOutlookReviewParams,
  HealthStatus,
  LicenseEconomics,
  LicenseEconomicsAuditEvent,
  LicenseEconomicsInput,
  LicenseEconomicsRetirement,
  LicenseEconomicsUpdate,
  ListForecastInputsParams,
  ListLicenseEconomicsParams,
  ListScenariosParams,
  OutlookReview,
  OutlookReviewPublish,
  OutlookReviewUpdate,
  Problem,
  PublishOutlookReviewParams,
  Scenario,
  ScenarioAction,
  ScenarioAuditEvent,
  ScenarioComparison,
  ScenarioComparisonInput,
  ScenarioDriverInput,
  ScenarioInput,
  ScenarioPromotion,
  ScenarioPromotionInput,
  ScenarioQuestionTemplate,
  ScenarioSummary,
  UpdateOutlookReviewParams,
  WorkspaceCompanies
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * Returns server health status
 * @summary Health check
 */
export const healthCheck = async ( options?: Parameters<typeof customFetch>[1]): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetWorkspaceCompaniesUrl = () => {




  return `/api/workspace/companies`
}

/**
 * Returns the companies this Budget-vs-Actuals workspace can scope to, using the same Budget Explorer storage discovery and workspace allowlist configuration as sibling TekLedger apps.
 * @summary List companies available in this workspace
 */
export const getWorkspaceCompanies = async ( options?: Parameters<typeof customFetch>[1]): Promise<WorkspaceCompanies> => {

  return customFetch<WorkspaceCompanies>(getGetWorkspaceCompaniesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWorkspaceCompaniesQueryKey = () => {
    return [
    `/api/workspace/companies`
    ] as const;
    }


export const getGetWorkspaceCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof getWorkspaceCompanies>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceCompanies>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkspaceCompaniesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkspaceCompanies>>> = ({ signal }) => getWorkspaceCompanies({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceCompanies>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWorkspaceCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkspaceCompanies>>>
export type GetWorkspaceCompaniesQueryError = ErrorType<ErrorResponse>


/**
 * @summary List companies available in this workspace
 */

export function useGetWorkspaceCompanies<TData = Awaited<ReturnType<typeof getWorkspaceCompanies>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceCompanies>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWorkspaceCompaniesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCertifiedActualsMonthlyUrl = (params: GetCertifiedActualsMonthlyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/actuals/monthly?${stringifiedParams}` : `/api/actuals/monthly`
}

/**
 * Returns the authoritative certified period and normalized transactions for one entity, source type, fiscal year, and accounting period. Superseded and correction batches are resolved by the Actuals Explorer authority register before this response is returned.
 * @summary Read certified monthly Actuals
 */
export const getCertifiedActualsMonthly = async (params: GetCertifiedActualsMonthlyParams, options?: Parameters<typeof customFetch>[1]): Promise<CertifiedActualsMonthlyResponse> => {

  return customFetch<CertifiedActualsMonthlyResponse>(getGetCertifiedActualsMonthlyUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCertifiedActualsMonthlyQueryKey = (params?: GetCertifiedActualsMonthlyParams,) => {
    return [
    `/api/actuals/monthly`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCertifiedActualsMonthlyQueryOptions = <TData = Awaited<ReturnType<typeof getCertifiedActualsMonthly>>, TError = ErrorType<Problem>>(params: GetCertifiedActualsMonthlyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCertifiedActualsMonthly>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCertifiedActualsMonthlyQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCertifiedActualsMonthly>>> = ({ signal }) => getCertifiedActualsMonthly(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCertifiedActualsMonthly>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCertifiedActualsMonthlyQueryResult = NonNullable<Awaited<ReturnType<typeof getCertifiedActualsMonthly>>>
export type GetCertifiedActualsMonthlyQueryError = ErrorType<Problem>


/**
 * @summary Read certified monthly Actuals
 */

export function useGetCertifiedActualsMonthly<TData = Awaited<ReturnType<typeof getCertifiedActualsMonthly>>, TError = ErrorType<Problem>>(
 params: GetCertifiedActualsMonthlyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCertifiedActualsMonthly>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCertifiedActualsMonthlyQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetFiscalYearUrl = (params: GetFiscalYearParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/fiscal-year?${stringifiedParams}` : `/api/fiscal-year`
}

/**
 * Returns the current published budget and certified Actuals handoff for a Fiscal Year.
 * @summary Get Fiscal Year source readiness
 */
export const getFiscalYear = async (params: GetFiscalYearParams, options?: Parameters<typeof customFetch>[1]): Promise<FiscalYear> => {

  return customFetch<FiscalYear>(getGetFiscalYearUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFiscalYearQueryKey = (params?: GetFiscalYearParams,) => {
    return [
    `/api/fiscal-year`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFiscalYearQueryOptions = <TData = Awaited<ReturnType<typeof getFiscalYear>>, TError = ErrorType<ErrorResponse>>(params: GetFiscalYearParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFiscalYear>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFiscalYearQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFiscalYear>>> = ({ signal }) => getFiscalYear(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFiscalYear>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFiscalYearQueryResult = NonNullable<Awaited<ReturnType<typeof getFiscalYear>>>
export type GetFiscalYearQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get Fiscal Year source readiness
 */

export function useGetFiscalYear<TData = Awaited<ReturnType<typeof getFiscalYear>>, TError = ErrorType<ErrorResponse>>(
 params: GetFiscalYearParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFiscalYear>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetFiscalYearQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAvailableFiscalYearsUrl = (params: GetAvailableFiscalYearsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/fiscal-years?${stringifiedParams}` : `/api/fiscal-years`
}

/**
 * Returns Fiscal Years with source data available in Budget Explorer for the company.
 * @summary List available Fiscal Years
 */
export const getAvailableFiscalYears = async (params: GetAvailableFiscalYearsParams, options?: Parameters<typeof customFetch>[1]): Promise<AvailableFiscalYears> => {

  return customFetch<AvailableFiscalYears>(getGetAvailableFiscalYearsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAvailableFiscalYearsQueryKey = (params?: GetAvailableFiscalYearsParams,) => {
    return [
    `/api/fiscal-years`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAvailableFiscalYearsQueryOptions = <TData = Awaited<ReturnType<typeof getAvailableFiscalYears>>, TError = ErrorType<ErrorResponse>>(params: GetAvailableFiscalYearsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAvailableFiscalYears>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAvailableFiscalYearsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailableFiscalYears>>> = ({ signal }) => getAvailableFiscalYears(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAvailableFiscalYears>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAvailableFiscalYearsQueryResult = NonNullable<Awaited<ReturnType<typeof getAvailableFiscalYears>>>
export type GetAvailableFiscalYearsQueryError = ErrorType<ErrorResponse>


/**
 * @summary List available Fiscal Years
 */

export function useGetAvailableFiscalYears<TData = Awaited<ReturnType<typeof getAvailableFiscalYears>>, TError = ErrorType<ErrorResponse>>(
 params: GetAvailableFiscalYearsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAvailableFiscalYears>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAvailableFiscalYearsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetFiscalYearBudgetPreviewUrl = (params: GetFiscalYearBudgetPreviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/fiscal-year/budget-preview?${stringifiedParams}` : `/api/fiscal-year/budget-preview`
}

/**
 * Returns the selected published Budget Explorer revision with normalized monthly budget lines and source lineage. Actuals are not included.
 * @summary Preview the immutable published budget
 */
export const getFiscalYearBudgetPreview = async (params: GetFiscalYearBudgetPreviewParams, options?: Parameters<typeof customFetch>[1]): Promise<BudgetPreview> => {

  return customFetch<BudgetPreview>(getGetFiscalYearBudgetPreviewUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFiscalYearBudgetPreviewQueryKey = (params?: GetFiscalYearBudgetPreviewParams,) => {
    return [
    `/api/fiscal-year/budget-preview`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFiscalYearBudgetPreviewQueryOptions = <TData = Awaited<ReturnType<typeof getFiscalYearBudgetPreview>>, TError = ErrorType<ErrorResponse>>(params: GetFiscalYearBudgetPreviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFiscalYearBudgetPreview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFiscalYearBudgetPreviewQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFiscalYearBudgetPreview>>> = ({ signal }) => getFiscalYearBudgetPreview(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFiscalYearBudgetPreview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFiscalYearBudgetPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof getFiscalYearBudgetPreview>>>
export type GetFiscalYearBudgetPreviewQueryError = ErrorType<ErrorResponse>


/**
 * @summary Preview the immutable published budget
 */

export function useGetFiscalYearBudgetPreview<TData = Awaited<ReturnType<typeof getFiscalYearBudgetPreview>>, TError = ErrorType<ErrorResponse>>(
 params: GetFiscalYearBudgetPreviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFiscalYearBudgetPreview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetFiscalYearBudgetPreviewQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getImportFiscalYearUrl = () => {




  return `/api/fiscal-year/import`
}

/**
 * Idempotently records the approved budget and certified Actuals source lineage for a BvA review.
 * @summary Import compatible Fiscal Year sources
 */
export const importFiscalYear = async (fiscalYearImportInput: FiscalYearImportInput, options?: Parameters<typeof customFetch>[1]): Promise<FiscalYearImport> => {

  return customFetch<FiscalYearImport>(getImportFiscalYearUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(fiscalYearImportInput)
  }
);}





export const getImportFiscalYearMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importFiscalYear>>, TError,{data: BodyType<FiscalYearImportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importFiscalYear>>, TError,{data: BodyType<FiscalYearImportInput>}, TContext> => {

const mutationKey = ['importFiscalYear'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importFiscalYear>>, {data: BodyType<FiscalYearImportInput>}> = (props) => {
          const {data} = props ?? {};

          return  importFiscalYear(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportFiscalYearMutationResult = NonNullable<Awaited<ReturnType<typeof importFiscalYear>>>
    export type ImportFiscalYearMutationBody = BodyType<FiscalYearImportInput>
    export type ImportFiscalYearMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Import compatible Fiscal Year sources
 */
export const useImportFiscalYear = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importFiscalYear>>, TError,{data: BodyType<FiscalYearImportInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof importFiscalYear>>,
        TError,
        {data: BodyType<FiscalYearImportInput>},
        TContext
      > => {
      return useMutation(getImportFiscalYearMutationOptions(options));
    }

export const getGetBvaComparisonUrl = (params: GetBvaComparisonParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/bva/comparison?${stringifiedParams}` : `/api/bva/comparison`
}

/**
 * Discovers authoritative Budget and certified Actuals department coverage and calculates only a comparable department and period population. Incomplete coverage returns an explicit controlled state instead of a division-wide variance.
 * @summary Get a safe Budget versus Actual comparison
 */
export const getBvaComparison = async (params: GetBvaComparisonParams, options?: Parameters<typeof customFetch>[1]): Promise<BvaComparison> => {

  return customFetch<BvaComparison>(getGetBvaComparisonUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBvaComparisonQueryKey = (params?: GetBvaComparisonParams,) => {
    return [
    `/api/bva/comparison`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetBvaComparisonQueryOptions = <TData = Awaited<ReturnType<typeof getBvaComparison>>, TError = ErrorType<ErrorResponse>>(params: GetBvaComparisonParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBvaComparison>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBvaComparisonQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBvaComparison>>> = ({ signal }) => getBvaComparison(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBvaComparison>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBvaComparisonQueryResult = NonNullable<Awaited<ReturnType<typeof getBvaComparison>>>
export type GetBvaComparisonQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get a safe Budget versus Actual comparison
 */

export function useGetBvaComparison<TData = Awaited<ReturnType<typeof getBvaComparison>>, TError = ErrorType<ErrorResponse>>(
 params: GetBvaComparisonParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBvaComparison>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBvaComparisonQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetBvaTransactionEvidenceUrl = (params: GetBvaTransactionEvidenceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/bva/transactions?${stringifiedParams}` : `/api/bva/transactions`
}

/**
 * Returns authority-selected certified transactions through the requested accounting period for one department and GL account.
 * @summary Get certified Actuals evidence for one BvA account
 */
export const getBvaTransactionEvidence = async (params: GetBvaTransactionEvidenceParams, options?: Parameters<typeof customFetch>[1]): Promise<BvaTransactionEvidence> => {

  return customFetch<BvaTransactionEvidence>(getGetBvaTransactionEvidenceUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBvaTransactionEvidenceQueryKey = (params?: GetBvaTransactionEvidenceParams,) => {
    return [
    `/api/bva/transactions`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetBvaTransactionEvidenceQueryOptions = <TData = Awaited<ReturnType<typeof getBvaTransactionEvidence>>, TError = ErrorType<ErrorResponse>>(params: GetBvaTransactionEvidenceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBvaTransactionEvidence>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBvaTransactionEvidenceQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBvaTransactionEvidence>>> = ({ signal }) => getBvaTransactionEvidence(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBvaTransactionEvidence>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBvaTransactionEvidenceQueryResult = NonNullable<Awaited<ReturnType<typeof getBvaTransactionEvidence>>>
export type GetBvaTransactionEvidenceQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get certified Actuals evidence for one BvA account
 */

export function useGetBvaTransactionEvidence<TData = Awaited<ReturnType<typeof getBvaTransactionEvidence>>, TError = ErrorType<ErrorResponse>>(
 params: GetBvaTransactionEvidenceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBvaTransactionEvidence>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetBvaTransactionEvidenceQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getInitializeForecastRunUrl = () => {




  return `/api/forecast/runs`
}

export const initializeForecastRun = async (forecastRunInput: ForecastRunInput, options?: Parameters<typeof customFetch>[1]): Promise<ForecastOutlook> => {

  return customFetch<ForecastOutlook>(getInitializeForecastRunUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(forecastRunInput)
  }
);}





export const getInitializeForecastRunMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initializeForecastRun>>, TError,{data: BodyType<ForecastRunInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof initializeForecastRun>>, TError,{data: BodyType<ForecastRunInput>}, TContext> => {

const mutationKey = ['initializeForecastRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof initializeForecastRun>>, {data: BodyType<ForecastRunInput>}> = (props) => {
          const {data} = props ?? {};

          return  initializeForecastRun(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InitializeForecastRunMutationResult = NonNullable<Awaited<ReturnType<typeof initializeForecastRun>>>
    export type InitializeForecastRunMutationBody = BodyType<ForecastRunInput>
    export type InitializeForecastRunMutationError = ErrorType<unknown>

    export const useInitializeForecastRun = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initializeForecastRun>>, TError,{data: BodyType<ForecastRunInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof initializeForecastRun>>,
        TError,
        {data: BodyType<ForecastRunInput>},
        TContext
      > => {
      return useMutation(getInitializeForecastRunMutationOptions(options));
    }

export const getGetForecastOutlookUrl = (runId: string,) => {




  return `/api/forecast/runs/${runId}`
}

export const getForecastOutlook = async (runId: string, options?: Parameters<typeof customFetch>[1]): Promise<ForecastOutlook> => {

  return customFetch<ForecastOutlook>(getGetForecastOutlookUrl(runId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetForecastOutlookQueryKey = (runId: string,) => {
    return [
    `/api/forecast/runs/${runId}`
    ] as const;
    }


export const getGetForecastOutlookQueryOptions = <TData = Awaited<ReturnType<typeof getForecastOutlook>>, TError = ErrorType<unknown>>(runId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getForecastOutlook>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetForecastOutlookQueryKey(runId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getForecastOutlook>>> = ({ signal }) => getForecastOutlook(runId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: runId !== null && runId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getForecastOutlook>>, TError, TData> & { queryKey: QueryKey }
}

export type GetForecastOutlookQueryResult = NonNullable<Awaited<ReturnType<typeof getForecastOutlook>>>
export type GetForecastOutlookQueryError = ErrorType<unknown>



export function useGetForecastOutlook<TData = Awaited<ReturnType<typeof getForecastOutlook>>, TError = ErrorType<unknown>>(
 runId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getForecastOutlook>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetForecastOutlookQueryOptions(runId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateForecastLineUrl = (runId: string,
    lineId: string,) => {




  return `/api/forecast/runs/${runId}/lines/${lineId}`
}

export const updateForecastLine = async (runId: string,
    lineId: string,
    forecastLineUpdate: ForecastLineUpdate, options?: Parameters<typeof customFetch>[1]): Promise<ForecastLineUpdateResult> => {

  return customFetch<ForecastLineUpdateResult>(getUpdateForecastLineUrl(runId,lineId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(forecastLineUpdate)
  }
);}





export const getUpdateForecastLineMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateForecastLine>>, TError,{runId: string;lineId: string;data: BodyType<ForecastLineUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateForecastLine>>, TError,{runId: string;lineId: string;data: BodyType<ForecastLineUpdate>}, TContext> => {

const mutationKey = ['updateForecastLine'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateForecastLine>>, {runId: string;lineId: string;data: BodyType<ForecastLineUpdate>}> = (props) => {
          const {runId,lineId,data} = props ?? {};

          return  updateForecastLine(runId,lineId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateForecastLineMutationResult = NonNullable<Awaited<ReturnType<typeof updateForecastLine>>>
    export type UpdateForecastLineMutationBody = BodyType<ForecastLineUpdate>
    export type UpdateForecastLineMutationError = ErrorType<unknown>

    export const useUpdateForecastLine = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateForecastLine>>, TError,{runId: string;lineId: string;data: BodyType<ForecastLineUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateForecastLine>>,
        TError,
        {runId: string;lineId: string;data: BodyType<ForecastLineUpdate>},
        TContext
      > => {
      return useMutation(getUpdateForecastLineMutationOptions(options));
    }

export const getGetForecastAuditUrl = (runId: string,) => {




  return `/api/forecast/runs/${runId}/audit`
}

export const getForecastAudit = async (runId: string, options?: Parameters<typeof customFetch>[1]): Promise<ForecastAuditResponse> => {

  return customFetch<ForecastAuditResponse>(getGetForecastAuditUrl(runId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetForecastAuditQueryKey = (runId: string,) => {
    return [
    `/api/forecast/runs/${runId}/audit`
    ] as const;
    }


export const getGetForecastAuditQueryOptions = <TData = Awaited<ReturnType<typeof getForecastAudit>>, TError = ErrorType<unknown>>(runId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getForecastAudit>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetForecastAuditQueryKey(runId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getForecastAudit>>> = ({ signal }) => getForecastAudit(runId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: runId !== null && runId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getForecastAudit>>, TError, TData> & { queryKey: QueryKey }
}

export type GetForecastAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getForecastAudit>>>
export type GetForecastAuditQueryError = ErrorType<unknown>



export function useGetForecastAudit<TData = Awaited<ReturnType<typeof getForecastAudit>>, TError = ErrorType<unknown>>(
 runId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getForecastAudit>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetForecastAuditQueryOptions(runId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateForecastDecisionUrl = (runId: string,
    glAccount: string,) => {




  return `/api/forecast/runs/${runId}/decisions/${glAccount}`
}

export const updateForecastDecision = async (runId: string,
    glAccount: string,
    forecastDecisionUpdate: ForecastDecisionUpdate, options?: Parameters<typeof customFetch>[1]): Promise<ForecastLineUpdateResult> => {

  return customFetch<ForecastLineUpdateResult>(getUpdateForecastDecisionUrl(runId,glAccount),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(forecastDecisionUpdate)
  }
);}





export const getUpdateForecastDecisionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateForecastDecision>>, TError,{runId: string;glAccount: string;data: BodyType<ForecastDecisionUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateForecastDecision>>, TError,{runId: string;glAccount: string;data: BodyType<ForecastDecisionUpdate>}, TContext> => {

const mutationKey = ['updateForecastDecision'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateForecastDecision>>, {runId: string;glAccount: string;data: BodyType<ForecastDecisionUpdate>}> = (props) => {
          const {runId,glAccount,data} = props ?? {};

          return  updateForecastDecision(runId,glAccount,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateForecastDecisionMutationResult = NonNullable<Awaited<ReturnType<typeof updateForecastDecision>>>
    export type UpdateForecastDecisionMutationBody = BodyType<ForecastDecisionUpdate>
    export type UpdateForecastDecisionMutationError = ErrorType<unknown>

    export const useUpdateForecastDecision = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateForecastDecision>>, TError,{runId: string;glAccount: string;data: BodyType<ForecastDecisionUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateForecastDecision>>,
        TError,
        {runId: string;glAccount: string;data: BodyType<ForecastDecisionUpdate>},
        TContext
      > => {
      return useMutation(getUpdateForecastDecisionMutationOptions(options));
    }

export const getCompleteForecastRunUrl = (runId: string,) => {




  return `/api/forecast/runs/${runId}/complete`
}

export const completeForecastRun = async (runId: string, options?: Parameters<typeof customFetch>[1]): Promise<ForecastCompletion> => {

  return customFetch<ForecastCompletion>(getCompleteForecastRunUrl(runId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCompleteForecastRunMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeForecastRun>>, TError,{runId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof completeForecastRun>>, TError,{runId: string}, TContext> => {

const mutationKey = ['completeForecastRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeForecastRun>>, {runId: string}> = (props) => {
          const {runId} = props ?? {};

          return  completeForecastRun(runId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteForecastRunMutationResult = NonNullable<Awaited<ReturnType<typeof completeForecastRun>>>

    export type CompleteForecastRunMutationError = ErrorType<unknown>

    export const useCompleteForecastRun = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeForecastRun>>, TError,{runId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof completeForecastRun>>,
        TError,
        {runId: string},
        TContext
      > => {
      return useMutation(getCompleteForecastRunMutationOptions(options));
    }

export const getGetCurrentForecastUrl = (params: GetCurrentForecastParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/forecast/current?${stringifiedParams}` : `/api/forecast/current`
}

export const getCurrentForecast = async (params: GetCurrentForecastParams, options?: Parameters<typeof customFetch>[1]): Promise<ForecastOutlook> => {

  return customFetch<ForecastOutlook>(getGetCurrentForecastUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCurrentForecastQueryKey = (params?: GetCurrentForecastParams,) => {
    return [
    `/api/forecast/current`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCurrentForecastQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentForecast>>, TError = ErrorType<unknown>>(params: GetCurrentForecastParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentForecast>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentForecastQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentForecast>>> = ({ signal }) => getCurrentForecast(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentForecast>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCurrentForecastQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentForecast>>>
export type GetCurrentForecastQueryError = ErrorType<unknown>



export function useGetCurrentForecast<TData = Awaited<ReturnType<typeof getCurrentForecast>>, TError = ErrorType<unknown>>(
 params: GetCurrentForecastParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentForecast>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCurrentForecastQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetOutlookReviewUrl = (params: GetOutlookReviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/outlook-review?${stringifiedParams}` : `/api/outlook-review`
}

export const getOutlookReview = async (params: GetOutlookReviewParams, options?: Parameters<typeof customFetch>[1]): Promise<OutlookReview> => {

  return customFetch<OutlookReview>(getGetOutlookReviewUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOutlookReviewQueryKey = (params?: GetOutlookReviewParams,) => {
    return [
    `/api/outlook-review`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOutlookReviewQueryOptions = <TData = Awaited<ReturnType<typeof getOutlookReview>>, TError = ErrorType<ErrorResponse>>(params: GetOutlookReviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOutlookReview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOutlookReviewQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOutlookReview>>> = ({ signal }) => getOutlookReview(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOutlookReview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOutlookReviewQueryResult = NonNullable<Awaited<ReturnType<typeof getOutlookReview>>>
export type GetOutlookReviewQueryError = ErrorType<ErrorResponse>



export function useGetOutlookReview<TData = Awaited<ReturnType<typeof getOutlookReview>>, TError = ErrorType<ErrorResponse>>(
 params: GetOutlookReviewParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOutlookReview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOutlookReviewQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateOutlookReviewUrl = (params: UpdateOutlookReviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/outlook-review?${stringifiedParams}` : `/api/outlook-review`
}

export const updateOutlookReview = async (outlookReviewUpdate: OutlookReviewUpdate,
    params: UpdateOutlookReviewParams, options?: Parameters<typeof customFetch>[1]): Promise<OutlookReview> => {

  return customFetch<OutlookReview>(getUpdateOutlookReviewUrl(params),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(outlookReviewUpdate)
  }
);}





export const getUpdateOutlookReviewMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOutlookReview>>, TError,{data: BodyType<OutlookReviewUpdate>;params: UpdateOutlookReviewParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOutlookReview>>, TError,{data: BodyType<OutlookReviewUpdate>;params: UpdateOutlookReviewParams}, TContext> => {

const mutationKey = ['updateOutlookReview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOutlookReview>>, {data: BodyType<OutlookReviewUpdate>;params: UpdateOutlookReviewParams}> = (props) => {
          const {data,params} = props ?? {};

          return  updateOutlookReview(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOutlookReviewMutationResult = NonNullable<Awaited<ReturnType<typeof updateOutlookReview>>>
    export type UpdateOutlookReviewMutationBody = BodyType<OutlookReviewUpdate>
    export type UpdateOutlookReviewMutationError = ErrorType<ErrorResponse>

    export const useUpdateOutlookReview = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOutlookReview>>, TError,{data: BodyType<OutlookReviewUpdate>;params: UpdateOutlookReviewParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOutlookReview>>,
        TError,
        {data: BodyType<OutlookReviewUpdate>;params: UpdateOutlookReviewParams},
        TContext
      > => {
      return useMutation(getUpdateOutlookReviewMutationOptions(options));
    }

export const getPublishOutlookReviewUrl = (params: PublishOutlookReviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/outlook-review?${stringifiedParams}` : `/api/outlook-review`
}

export const publishOutlookReview = async (outlookReviewPublish: OutlookReviewPublish,
    params: PublishOutlookReviewParams, options?: Parameters<typeof customFetch>[1]): Promise<OutlookReview> => {

  return customFetch<OutlookReview>(getPublishOutlookReviewUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(outlookReviewPublish)
  }
);}





export const getPublishOutlookReviewMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishOutlookReview>>, TError,{data: BodyType<OutlookReviewPublish>;params: PublishOutlookReviewParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof publishOutlookReview>>, TError,{data: BodyType<OutlookReviewPublish>;params: PublishOutlookReviewParams}, TContext> => {

const mutationKey = ['publishOutlookReview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishOutlookReview>>, {data: BodyType<OutlookReviewPublish>;params: PublishOutlookReviewParams}> = (props) => {
          const {data,params} = props ?? {};

          return  publishOutlookReview(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublishOutlookReviewMutationResult = NonNullable<Awaited<ReturnType<typeof publishOutlookReview>>>
    export type PublishOutlookReviewMutationBody = BodyType<OutlookReviewPublish>
    export type PublishOutlookReviewMutationError = ErrorType<ErrorResponse>

    export const usePublishOutlookReview = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishOutlookReview>>, TError,{data: BodyType<OutlookReviewPublish>;params: PublishOutlookReviewParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof publishOutlookReview>>,
        TError,
        {data: BodyType<OutlookReviewPublish>;params: PublishOutlookReviewParams},
        TContext
      > => {
      return useMutation(getPublishOutlookReviewMutationOptions(options));
    }

export const getListForecastInputsUrl = (params: ListForecastInputsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/forecast/inputs?${stringifiedParams}` : `/api/forecast/inputs`
}

export const listForecastInputs = async (params: ListForecastInputsParams, options?: Parameters<typeof customFetch>[1]): Promise<ForecastInputList> => {

  return customFetch<ForecastInputList>(getListForecastInputsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListForecastInputsQueryKey = (params?: ListForecastInputsParams,) => {
    return [
    `/api/forecast/inputs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListForecastInputsQueryOptions = <TData = Awaited<ReturnType<typeof listForecastInputs>>, TError = ErrorType<ErrorResponse>>(params: ListForecastInputsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listForecastInputs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListForecastInputsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listForecastInputs>>> = ({ signal }) => listForecastInputs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listForecastInputs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListForecastInputsQueryResult = NonNullable<Awaited<ReturnType<typeof listForecastInputs>>>
export type ListForecastInputsQueryError = ErrorType<ErrorResponse>



export function useListForecastInputs<TData = Awaited<ReturnType<typeof listForecastInputs>>, TError = ErrorType<ErrorResponse>>(
 params: ListForecastInputsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listForecastInputs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListForecastInputsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateForecastInputUrl = (inputId: string,) => {




  return `/api/forecast/inputs/${inputId}`
}

export const updateForecastInput = async (inputId: string,
    forecastInputUpdate: ForecastInputUpdate, options?: Parameters<typeof customFetch>[1]): Promise<ForecastInputRecord> => {

  return customFetch<ForecastInputRecord>(getUpdateForecastInputUrl(inputId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(forecastInputUpdate)
  }
);}





export const getUpdateForecastInputMutationOptions = <TError = ErrorType<ErrorResponse | ForecastInputOverlap>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateForecastInput>>, TError,{inputId: string;data: BodyType<ForecastInputUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateForecastInput>>, TError,{inputId: string;data: BodyType<ForecastInputUpdate>}, TContext> => {

const mutationKey = ['updateForecastInput'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateForecastInput>>, {inputId: string;data: BodyType<ForecastInputUpdate>}> = (props) => {
          const {inputId,data} = props ?? {};

          return  updateForecastInput(inputId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateForecastInputMutationResult = NonNullable<Awaited<ReturnType<typeof updateForecastInput>>>
    export type UpdateForecastInputMutationBody = BodyType<ForecastInputUpdate>
    export type UpdateForecastInputMutationError = ErrorType<ErrorResponse | ForecastInputOverlap>

    export const useUpdateForecastInput = <TError = ErrorType<ErrorResponse | ForecastInputOverlap>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateForecastInput>>, TError,{inputId: string;data: BodyType<ForecastInputUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateForecastInput>>,
        TError,
        {inputId: string;data: BodyType<ForecastInputUpdate>},
        TContext
      > => {
      return useMutation(getUpdateForecastInputMutationOptions(options));
    }

export const getChangeForecastInputStatusUrl = (inputId: string,) => {




  return `/api/forecast/inputs/${inputId}/status`
}

export const changeForecastInputStatus = async (inputId: string,
    forecastInputStatusChange: ForecastInputStatusChange, options?: Parameters<typeof customFetch>[1]): Promise<ForecastInputRecord> => {

  return customFetch<ForecastInputRecord>(getChangeForecastInputStatusUrl(inputId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(forecastInputStatusChange)
  }
);}





export const getChangeForecastInputStatusMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeForecastInputStatus>>, TError,{inputId: string;data: BodyType<ForecastInputStatusChange>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof changeForecastInputStatus>>, TError,{inputId: string;data: BodyType<ForecastInputStatusChange>}, TContext> => {

const mutationKey = ['changeForecastInputStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeForecastInputStatus>>, {inputId: string;data: BodyType<ForecastInputStatusChange>}> = (props) => {
          const {inputId,data} = props ?? {};

          return  changeForecastInputStatus(inputId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangeForecastInputStatusMutationResult = NonNullable<Awaited<ReturnType<typeof changeForecastInputStatus>>>
    export type ChangeForecastInputStatusMutationBody = BodyType<ForecastInputStatusChange>
    export type ChangeForecastInputStatusMutationError = ErrorType<ErrorResponse>

    export const useChangeForecastInputStatus = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeForecastInputStatus>>, TError,{inputId: string;data: BodyType<ForecastInputStatusChange>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof changeForecastInputStatus>>,
        TError,
        {inputId: string;data: BodyType<ForecastInputStatusChange>},
        TContext
      > => {
      return useMutation(getChangeForecastInputStatusMutationOptions(options));
    }

export const getRefreshForecastInputsUrl = (runId: string,) => {




  return `/api/forecast/runs/${runId}/refresh-inputs`
}

export const refreshForecastInputs = async (runId: string,
    forecastRefreshInput: ForecastRefreshInput, options?: Parameters<typeof customFetch>[1]): Promise<ForecastOutlook> => {

  return customFetch<ForecastOutlook>(getRefreshForecastInputsUrl(runId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(forecastRefreshInput)
  }
);}





export const getRefreshForecastInputsMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshForecastInputs>>, TError,{runId: string;data: BodyType<ForecastRefreshInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshForecastInputs>>, TError,{runId: string;data: BodyType<ForecastRefreshInput>}, TContext> => {

const mutationKey = ['refreshForecastInputs'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshForecastInputs>>, {runId: string;data: BodyType<ForecastRefreshInput>}> = (props) => {
          const {runId,data} = props ?? {};

          return  refreshForecastInputs(runId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshForecastInputsMutationResult = NonNullable<Awaited<ReturnType<typeof refreshForecastInputs>>>
    export type RefreshForecastInputsMutationBody = BodyType<ForecastRefreshInput>
    export type RefreshForecastInputsMutationError = ErrorType<ErrorResponse>

    export const useRefreshForecastInputs = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshForecastInputs>>, TError,{runId: string;data: BodyType<ForecastRefreshInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof refreshForecastInputs>>,
        TError,
        {runId: string;data: BodyType<ForecastRefreshInput>},
        TContext
      > => {
      return useMutation(getRefreshForecastInputsMutationOptions(options));
    }

export const getCreateForecastAccrualUrl = () => {




  return `/api/forecast/accruals`
}

export const createForecastAccrual = async (forecastAccrualInput: ForecastAccrualInput, options?: Parameters<typeof customFetch>[1]): Promise<ForecastInputRecord> => {

  return customFetch<ForecastInputRecord>(getCreateForecastAccrualUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(forecastAccrualInput)
  }
);}





export const getCreateForecastAccrualMutationOptions = <TError = ErrorType<ForecastInputOverlap>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createForecastAccrual>>, TError,{data: BodyType<ForecastAccrualInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createForecastAccrual>>, TError,{data: BodyType<ForecastAccrualInput>}, TContext> => {

const mutationKey = ['createForecastAccrual'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createForecastAccrual>>, {data: BodyType<ForecastAccrualInput>}> = (props) => {
          const {data} = props ?? {};

          return  createForecastAccrual(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateForecastAccrualMutationResult = NonNullable<Awaited<ReturnType<typeof createForecastAccrual>>>
    export type CreateForecastAccrualMutationBody = BodyType<ForecastAccrualInput>
    export type CreateForecastAccrualMutationError = ErrorType<ForecastInputOverlap>

    export const useCreateForecastAccrual = <TError = ErrorType<ForecastInputOverlap>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createForecastAccrual>>, TError,{data: BodyType<ForecastAccrualInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createForecastAccrual>>,
        TError,
        {data: BodyType<ForecastAccrualInput>},
        TContext
      > => {
      return useMutation(getCreateForecastAccrualMutationOptions(options));
    }

export const getRetireForecastAccrualUrl = (accrualId: string,) => {




  return `/api/forecast/accruals/${accrualId}/retire`
}

export const retireForecastAccrual = async (accrualId: string,
    forecastAccrualRetirement: ForecastAccrualRetirement, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getRetireForecastAccrualUrl(accrualId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(forecastAccrualRetirement)
  }
);}





export const getRetireForecastAccrualMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retireForecastAccrual>>, TError,{accrualId: string;data: BodyType<ForecastAccrualRetirement>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof retireForecastAccrual>>, TError,{accrualId: string;data: BodyType<ForecastAccrualRetirement>}, TContext> => {

const mutationKey = ['retireForecastAccrual'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retireForecastAccrual>>, {accrualId: string;data: BodyType<ForecastAccrualRetirement>}> = (props) => {
          const {accrualId,data} = props ?? {};

          return  retireForecastAccrual(accrualId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetireForecastAccrualMutationResult = NonNullable<Awaited<ReturnType<typeof retireForecastAccrual>>>
    export type RetireForecastAccrualMutationBody = BodyType<ForecastAccrualRetirement>
    export type RetireForecastAccrualMutationError = ErrorType<unknown>

    export const useRetireForecastAccrual = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retireForecastAccrual>>, TError,{accrualId: string;data: BodyType<ForecastAccrualRetirement>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof retireForecastAccrual>>,
        TError,
        {accrualId: string;data: BodyType<ForecastAccrualRetirement>},
        TContext
      > => {
      return useMutation(getRetireForecastAccrualMutationOptions(options));
    }

export const getCreateForecastCommitmentUrl = () => {




  return `/api/forecast/commitments`
}

export const createForecastCommitment = async (forecastCommitmentInput: ForecastCommitmentInput, options?: Parameters<typeof customFetch>[1]): Promise<ForecastInputRecord> => {

  return customFetch<ForecastInputRecord>(getCreateForecastCommitmentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(forecastCommitmentInput)
  }
);}





export const getCreateForecastCommitmentMutationOptions = <TError = ErrorType<ForecastInputOverlap>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createForecastCommitment>>, TError,{data: BodyType<ForecastCommitmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createForecastCommitment>>, TError,{data: BodyType<ForecastCommitmentInput>}, TContext> => {

const mutationKey = ['createForecastCommitment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createForecastCommitment>>, {data: BodyType<ForecastCommitmentInput>}> = (props) => {
          const {data} = props ?? {};

          return  createForecastCommitment(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateForecastCommitmentMutationResult = NonNullable<Awaited<ReturnType<typeof createForecastCommitment>>>
    export type CreateForecastCommitmentMutationBody = BodyType<ForecastCommitmentInput>
    export type CreateForecastCommitmentMutationError = ErrorType<ForecastInputOverlap>

    export const useCreateForecastCommitment = <TError = ErrorType<ForecastInputOverlap>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createForecastCommitment>>, TError,{data: BodyType<ForecastCommitmentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createForecastCommitment>>,
        TError,
        {data: BodyType<ForecastCommitmentInput>},
        TContext
      > => {
      return useMutation(getCreateForecastCommitmentMutationOptions(options));
    }

export const getCreateForecastPlannedSpendUrl = () => {




  return `/api/forecast/planned-spend`
}

export const createForecastPlannedSpend = async (forecastPlannedSpendInput: ForecastPlannedSpendInput, options?: Parameters<typeof customFetch>[1]): Promise<ForecastInputRecord> => {

  return customFetch<ForecastInputRecord>(getCreateForecastPlannedSpendUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(forecastPlannedSpendInput)
  }
);}





export const getCreateForecastPlannedSpendMutationOptions = <TError = ErrorType<ForecastInputOverlap>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createForecastPlannedSpend>>, TError,{data: BodyType<ForecastPlannedSpendInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createForecastPlannedSpend>>, TError,{data: BodyType<ForecastPlannedSpendInput>}, TContext> => {

const mutationKey = ['createForecastPlannedSpend'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createForecastPlannedSpend>>, {data: BodyType<ForecastPlannedSpendInput>}> = (props) => {
          const {data} = props ?? {};

          return  createForecastPlannedSpend(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateForecastPlannedSpendMutationResult = NonNullable<Awaited<ReturnType<typeof createForecastPlannedSpend>>>
    export type CreateForecastPlannedSpendMutationBody = BodyType<ForecastPlannedSpendInput>
    export type CreateForecastPlannedSpendMutationError = ErrorType<ForecastInputOverlap>

    export const useCreateForecastPlannedSpend = <TError = ErrorType<ForecastInputOverlap>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createForecastPlannedSpend>>, TError,{data: BodyType<ForecastPlannedSpendInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createForecastPlannedSpend>>,
        TError,
        {data: BodyType<ForecastPlannedSpendInput>},
        TContext
      > => {
      return useMutation(getCreateForecastPlannedSpendMutationOptions(options));
    }

export const getListLicenseEconomicsUrl = (params: ListLicenseEconomicsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/license-economics?${stringifiedParams}` : `/api/license-economics`
}

export const listLicenseEconomics = async (params: ListLicenseEconomicsParams, options?: Parameters<typeof customFetch>[1]): Promise<LicenseEconomics[]> => {

  return customFetch<LicenseEconomics[]>(getListLicenseEconomicsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLicenseEconomicsQueryKey = (params?: ListLicenseEconomicsParams,) => {
    return [
    `/api/license-economics`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLicenseEconomicsQueryOptions = <TData = Awaited<ReturnType<typeof listLicenseEconomics>>, TError = ErrorType<ErrorResponse>>(params: ListLicenseEconomicsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLicenseEconomics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLicenseEconomicsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLicenseEconomics>>> = ({ signal }) => listLicenseEconomics(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLicenseEconomics>>, TError, TData> & { queryKey: QueryKey }
}

export type ListLicenseEconomicsQueryResult = NonNullable<Awaited<ReturnType<typeof listLicenseEconomics>>>
export type ListLicenseEconomicsQueryError = ErrorType<ErrorResponse>



export function useListLicenseEconomics<TData = Awaited<ReturnType<typeof listLicenseEconomics>>, TError = ErrorType<ErrorResponse>>(
 params: ListLicenseEconomicsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLicenseEconomics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListLicenseEconomicsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateLicenseEconomicsUrl = () => {




  return `/api/license-economics`
}

export const createLicenseEconomics = async (licenseEconomicsInput: LicenseEconomicsInput, options?: Parameters<typeof customFetch>[1]): Promise<LicenseEconomics> => {

  return customFetch<LicenseEconomics>(getCreateLicenseEconomicsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(licenseEconomicsInput)
  }
);}





export const getCreateLicenseEconomicsMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLicenseEconomics>>, TError,{data: BodyType<LicenseEconomicsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLicenseEconomics>>, TError,{data: BodyType<LicenseEconomicsInput>}, TContext> => {

const mutationKey = ['createLicenseEconomics'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLicenseEconomics>>, {data: BodyType<LicenseEconomicsInput>}> = (props) => {
          const {data} = props ?? {};

          return  createLicenseEconomics(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLicenseEconomicsMutationResult = NonNullable<Awaited<ReturnType<typeof createLicenseEconomics>>>
    export type CreateLicenseEconomicsMutationBody = BodyType<LicenseEconomicsInput>
    export type CreateLicenseEconomicsMutationError = ErrorType<ErrorResponse>

    export const useCreateLicenseEconomics = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLicenseEconomics>>, TError,{data: BodyType<LicenseEconomicsInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createLicenseEconomics>>,
        TError,
        {data: BodyType<LicenseEconomicsInput>},
        TContext
      > => {
      return useMutation(getCreateLicenseEconomicsMutationOptions(options));
    }

export const getGetLicenseEconomicsUrl = (licenseEconomicsId: string,) => {




  return `/api/license-economics/${licenseEconomicsId}`
}

export const getLicenseEconomics = async (licenseEconomicsId: string, options?: Parameters<typeof customFetch>[1]): Promise<LicenseEconomics> => {

  return customFetch<LicenseEconomics>(getGetLicenseEconomicsUrl(licenseEconomicsId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLicenseEconomicsQueryKey = (licenseEconomicsId: string,) => {
    return [
    `/api/license-economics/${licenseEconomicsId}`
    ] as const;
    }


export const getGetLicenseEconomicsQueryOptions = <TData = Awaited<ReturnType<typeof getLicenseEconomics>>, TError = ErrorType<ErrorResponse>>(licenseEconomicsId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLicenseEconomics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLicenseEconomicsQueryKey(licenseEconomicsId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLicenseEconomics>>> = ({ signal }) => getLicenseEconomics(licenseEconomicsId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: licenseEconomicsId !== null && licenseEconomicsId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLicenseEconomics>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLicenseEconomicsQueryResult = NonNullable<Awaited<ReturnType<typeof getLicenseEconomics>>>
export type GetLicenseEconomicsQueryError = ErrorType<ErrorResponse>



export function useGetLicenseEconomics<TData = Awaited<ReturnType<typeof getLicenseEconomics>>, TError = ErrorType<ErrorResponse>>(
 licenseEconomicsId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLicenseEconomics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLicenseEconomicsQueryOptions(licenseEconomicsId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateLicenseEconomicsUrl = (licenseEconomicsId: string,) => {




  return `/api/license-economics/${licenseEconomicsId}`
}

export const updateLicenseEconomics = async (licenseEconomicsId: string,
    licenseEconomicsUpdate: LicenseEconomicsUpdate, options?: Parameters<typeof customFetch>[1]): Promise<LicenseEconomics> => {

  return customFetch<LicenseEconomics>(getUpdateLicenseEconomicsUrl(licenseEconomicsId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(licenseEconomicsUpdate)
  }
);}





export const getUpdateLicenseEconomicsMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLicenseEconomics>>, TError,{licenseEconomicsId: string;data: BodyType<LicenseEconomicsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLicenseEconomics>>, TError,{licenseEconomicsId: string;data: BodyType<LicenseEconomicsUpdate>}, TContext> => {

const mutationKey = ['updateLicenseEconomics'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLicenseEconomics>>, {licenseEconomicsId: string;data: BodyType<LicenseEconomicsUpdate>}> = (props) => {
          const {licenseEconomicsId,data} = props ?? {};

          return  updateLicenseEconomics(licenseEconomicsId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLicenseEconomicsMutationResult = NonNullable<Awaited<ReturnType<typeof updateLicenseEconomics>>>
    export type UpdateLicenseEconomicsMutationBody = BodyType<LicenseEconomicsUpdate>
    export type UpdateLicenseEconomicsMutationError = ErrorType<ErrorResponse>

    export const useUpdateLicenseEconomics = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLicenseEconomics>>, TError,{licenseEconomicsId: string;data: BodyType<LicenseEconomicsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateLicenseEconomics>>,
        TError,
        {licenseEconomicsId: string;data: BodyType<LicenseEconomicsUpdate>},
        TContext
      > => {
      return useMutation(getUpdateLicenseEconomicsMutationOptions(options));
    }

export const getRetireLicenseEconomicsUrl = (licenseEconomicsId: string,) => {




  return `/api/license-economics/${licenseEconomicsId}`
}

export const retireLicenseEconomics = async (licenseEconomicsId: string,
    licenseEconomicsRetirement: LicenseEconomicsRetirement, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getRetireLicenseEconomicsUrl(licenseEconomicsId),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(licenseEconomicsRetirement)
  }
);}





export const getRetireLicenseEconomicsMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retireLicenseEconomics>>, TError,{licenseEconomicsId: string;data: BodyType<LicenseEconomicsRetirement>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof retireLicenseEconomics>>, TError,{licenseEconomicsId: string;data: BodyType<LicenseEconomicsRetirement>}, TContext> => {

const mutationKey = ['retireLicenseEconomics'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retireLicenseEconomics>>, {licenseEconomicsId: string;data: BodyType<LicenseEconomicsRetirement>}> = (props) => {
          const {licenseEconomicsId,data} = props ?? {};

          return  retireLicenseEconomics(licenseEconomicsId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetireLicenseEconomicsMutationResult = NonNullable<Awaited<ReturnType<typeof retireLicenseEconomics>>>
    export type RetireLicenseEconomicsMutationBody = BodyType<LicenseEconomicsRetirement>
    export type RetireLicenseEconomicsMutationError = ErrorType<ErrorResponse>

    export const useRetireLicenseEconomics = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retireLicenseEconomics>>, TError,{licenseEconomicsId: string;data: BodyType<LicenseEconomicsRetirement>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof retireLicenseEconomics>>,
        TError,
        {licenseEconomicsId: string;data: BodyType<LicenseEconomicsRetirement>},
        TContext
      > => {
      return useMutation(getRetireLicenseEconomicsMutationOptions(options));
    }

export const getGetLicenseEconomicsAuditUrl = (licenseEconomicsId: string,) => {




  return `/api/license-economics/${licenseEconomicsId}/audit`
}

export const getLicenseEconomicsAudit = async (licenseEconomicsId: string, options?: Parameters<typeof customFetch>[1]): Promise<LicenseEconomicsAuditEvent[]> => {

  return customFetch<LicenseEconomicsAuditEvent[]>(getGetLicenseEconomicsAuditUrl(licenseEconomicsId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLicenseEconomicsAuditQueryKey = (licenseEconomicsId: string,) => {
    return [
    `/api/license-economics/${licenseEconomicsId}/audit`
    ] as const;
    }


export const getGetLicenseEconomicsAuditQueryOptions = <TData = Awaited<ReturnType<typeof getLicenseEconomicsAudit>>, TError = ErrorType<ErrorResponse>>(licenseEconomicsId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLicenseEconomicsAudit>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLicenseEconomicsAuditQueryKey(licenseEconomicsId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLicenseEconomicsAudit>>> = ({ signal }) => getLicenseEconomicsAudit(licenseEconomicsId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: licenseEconomicsId !== null && licenseEconomicsId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLicenseEconomicsAudit>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLicenseEconomicsAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getLicenseEconomicsAudit>>>
export type GetLicenseEconomicsAuditQueryError = ErrorType<ErrorResponse>



export function useGetLicenseEconomicsAudit<TData = Awaited<ReturnType<typeof getLicenseEconomicsAudit>>, TError = ErrorType<ErrorResponse>>(
 licenseEconomicsId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLicenseEconomicsAudit>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLicenseEconomicsAuditQueryOptions(licenseEconomicsId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListScenarioQuestionTemplatesUrl = () => {




  return `/api/scenario-question-templates`
}

export const listScenarioQuestionTemplates = async ( options?: Parameters<typeof customFetch>[1]): Promise<ScenarioQuestionTemplate[]> => {

  return customFetch<ScenarioQuestionTemplate[]>(getListScenarioQuestionTemplatesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListScenarioQuestionTemplatesQueryKey = () => {
    return [
    `/api/scenario-question-templates`
    ] as const;
    }


export const getListScenarioQuestionTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof listScenarioQuestionTemplates>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listScenarioQuestionTemplates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListScenarioQuestionTemplatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listScenarioQuestionTemplates>>> = ({ signal }) => listScenarioQuestionTemplates({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listScenarioQuestionTemplates>>, TError, TData> & { queryKey: QueryKey }
}

export type ListScenarioQuestionTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof listScenarioQuestionTemplates>>>
export type ListScenarioQuestionTemplatesQueryError = ErrorType<unknown>



export function useListScenarioQuestionTemplates<TData = Awaited<ReturnType<typeof listScenarioQuestionTemplates>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listScenarioQuestionTemplates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListScenarioQuestionTemplatesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListScenariosUrl = (params: ListScenariosParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/scenarios?${stringifiedParams}` : `/api/scenarios`
}

export const listScenarios = async (params: ListScenariosParams, options?: Parameters<typeof customFetch>[1]): Promise<ScenarioSummary[]> => {

  return customFetch<ScenarioSummary[]>(getListScenariosUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListScenariosQueryKey = (params?: ListScenariosParams,) => {
    return [
    `/api/scenarios`, ...(params ? [params] : [])
    ] as const;
    }


export const getListScenariosQueryOptions = <TData = Awaited<ReturnType<typeof listScenarios>>, TError = ErrorType<ErrorResponse>>(params: ListScenariosParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listScenarios>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListScenariosQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listScenarios>>> = ({ signal }) => listScenarios(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listScenarios>>, TError, TData> & { queryKey: QueryKey }
}

export type ListScenariosQueryResult = NonNullable<Awaited<ReturnType<typeof listScenarios>>>
export type ListScenariosQueryError = ErrorType<ErrorResponse>



export function useListScenarios<TData = Awaited<ReturnType<typeof listScenarios>>, TError = ErrorType<ErrorResponse>>(
 params: ListScenariosParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listScenarios>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListScenariosQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateScenarioUrl = () => {




  return `/api/scenarios`
}

export const createScenario = async (scenarioInput: ScenarioInput, options?: Parameters<typeof customFetch>[1]): Promise<Scenario> => {

  return customFetch<Scenario>(getCreateScenarioUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scenarioInput)
  }
);}





export const getCreateScenarioMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createScenario>>, TError,{data: BodyType<ScenarioInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createScenario>>, TError,{data: BodyType<ScenarioInput>}, TContext> => {

const mutationKey = ['createScenario'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createScenario>>, {data: BodyType<ScenarioInput>}> = (props) => {
          const {data} = props ?? {};

          return  createScenario(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateScenarioMutationResult = NonNullable<Awaited<ReturnType<typeof createScenario>>>
    export type CreateScenarioMutationBody = BodyType<ScenarioInput>
    export type CreateScenarioMutationError = ErrorType<ErrorResponse>

    export const useCreateScenario = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createScenario>>, TError,{data: BodyType<ScenarioInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createScenario>>,
        TError,
        {data: BodyType<ScenarioInput>},
        TContext
      > => {
      return useMutation(getCreateScenarioMutationOptions(options));
    }

export const getGetScenarioUrl = (scenarioId: string,) => {




  return `/api/scenarios/${scenarioId}`
}

export const getScenario = async (scenarioId: string, options?: Parameters<typeof customFetch>[1]): Promise<Scenario> => {

  return customFetch<Scenario>(getGetScenarioUrl(scenarioId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetScenarioQueryKey = (scenarioId: string,) => {
    return [
    `/api/scenarios/${scenarioId}`
    ] as const;
    }


export const getGetScenarioQueryOptions = <TData = Awaited<ReturnType<typeof getScenario>>, TError = ErrorType<ErrorResponse>>(scenarioId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getScenario>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScenarioQueryKey(scenarioId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScenario>>> = ({ signal }) => getScenario(scenarioId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: scenarioId !== null && scenarioId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getScenario>>, TError, TData> & { queryKey: QueryKey }
}

export type GetScenarioQueryResult = NonNullable<Awaited<ReturnType<typeof getScenario>>>
export type GetScenarioQueryError = ErrorType<ErrorResponse>



export function useGetScenario<TData = Awaited<ReturnType<typeof getScenario>>, TError = ErrorType<ErrorResponse>>(
 scenarioId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getScenario>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetScenarioQueryOptions(scenarioId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAddScenarioDriverUrl = (scenarioId: string,) => {




  return `/api/scenarios/${scenarioId}/drivers`
}

export const addScenarioDriver = async (scenarioId: string,
    scenarioDriverInput: ScenarioDriverInput, options?: Parameters<typeof customFetch>[1]): Promise<Scenario> => {

  return customFetch<Scenario>(getAddScenarioDriverUrl(scenarioId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scenarioDriverInput)
  }
);}





export const getAddScenarioDriverMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addScenarioDriver>>, TError,{scenarioId: string;data: BodyType<ScenarioDriverInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addScenarioDriver>>, TError,{scenarioId: string;data: BodyType<ScenarioDriverInput>}, TContext> => {

const mutationKey = ['addScenarioDriver'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addScenarioDriver>>, {scenarioId: string;data: BodyType<ScenarioDriverInput>}> = (props) => {
          const {scenarioId,data} = props ?? {};

          return  addScenarioDriver(scenarioId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddScenarioDriverMutationResult = NonNullable<Awaited<ReturnType<typeof addScenarioDriver>>>
    export type AddScenarioDriverMutationBody = BodyType<ScenarioDriverInput>
    export type AddScenarioDriverMutationError = ErrorType<ErrorResponse>

    export const useAddScenarioDriver = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addScenarioDriver>>, TError,{scenarioId: string;data: BodyType<ScenarioDriverInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addScenarioDriver>>,
        TError,
        {scenarioId: string;data: BodyType<ScenarioDriverInput>},
        TContext
      > => {
      return useMutation(getAddScenarioDriverMutationOptions(options));
    }

export const getRecomputeScenarioUrl = (scenarioId: string,) => {




  return `/api/scenarios/${scenarioId}/recompute`
}

export const recomputeScenario = async (scenarioId: string,
    scenarioAction: ScenarioAction, options?: Parameters<typeof customFetch>[1]): Promise<Scenario> => {

  return customFetch<Scenario>(getRecomputeScenarioUrl(scenarioId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scenarioAction)
  }
);}





export const getRecomputeScenarioMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recomputeScenario>>, TError,{scenarioId: string;data: BodyType<ScenarioAction>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recomputeScenario>>, TError,{scenarioId: string;data: BodyType<ScenarioAction>}, TContext> => {

const mutationKey = ['recomputeScenario'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recomputeScenario>>, {scenarioId: string;data: BodyType<ScenarioAction>}> = (props) => {
          const {scenarioId,data} = props ?? {};

          return  recomputeScenario(scenarioId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecomputeScenarioMutationResult = NonNullable<Awaited<ReturnType<typeof recomputeScenario>>>
    export type RecomputeScenarioMutationBody = BodyType<ScenarioAction>
    export type RecomputeScenarioMutationError = ErrorType<ErrorResponse>

    export const useRecomputeScenario = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recomputeScenario>>, TError,{scenarioId: string;data: BodyType<ScenarioAction>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof recomputeScenario>>,
        TError,
        {scenarioId: string;data: BodyType<ScenarioAction>},
        TContext
      > => {
      return useMutation(getRecomputeScenarioMutationOptions(options));
    }

export const getCompareScenariosUrl = () => {




  return `/api/scenarios/compare`
}

export const compareScenarios = async (scenarioComparisonInput: ScenarioComparisonInput, options?: Parameters<typeof customFetch>[1]): Promise<ScenarioComparison> => {

  return customFetch<ScenarioComparison>(getCompareScenariosUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scenarioComparisonInput)
  }
);}





export const getCompareScenariosMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof compareScenarios>>, TError,{data: BodyType<ScenarioComparisonInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof compareScenarios>>, TError,{data: BodyType<ScenarioComparisonInput>}, TContext> => {

const mutationKey = ['compareScenarios'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof compareScenarios>>, {data: BodyType<ScenarioComparisonInput>}> = (props) => {
          const {data} = props ?? {};

          return  compareScenarios(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompareScenariosMutationResult = NonNullable<Awaited<ReturnType<typeof compareScenarios>>>
    export type CompareScenariosMutationBody = BodyType<ScenarioComparisonInput>
    export type CompareScenariosMutationError = ErrorType<ErrorResponse>

    export const useCompareScenarios = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof compareScenarios>>, TError,{data: BodyType<ScenarioComparisonInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof compareScenarios>>,
        TError,
        {data: BodyType<ScenarioComparisonInput>},
        TContext
      > => {
      return useMutation(getCompareScenariosMutationOptions(options));
    }

export const getGetScenarioAuditUrl = (scenarioId: string,) => {




  return `/api/scenarios/${scenarioId}/audit`
}

export const getScenarioAudit = async (scenarioId: string, options?: Parameters<typeof customFetch>[1]): Promise<ScenarioAuditEvent[]> => {

  return customFetch<ScenarioAuditEvent[]>(getGetScenarioAuditUrl(scenarioId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetScenarioAuditQueryKey = (scenarioId: string,) => {
    return [
    `/api/scenarios/${scenarioId}/audit`
    ] as const;
    }


export const getGetScenarioAuditQueryOptions = <TData = Awaited<ReturnType<typeof getScenarioAudit>>, TError = ErrorType<unknown>>(scenarioId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getScenarioAudit>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScenarioAuditQueryKey(scenarioId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScenarioAudit>>> = ({ signal }) => getScenarioAudit(scenarioId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: scenarioId !== null && scenarioId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getScenarioAudit>>, TError, TData> & { queryKey: QueryKey }
}

export type GetScenarioAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getScenarioAudit>>>
export type GetScenarioAuditQueryError = ErrorType<unknown>



export function useGetScenarioAudit<TData = Awaited<ReturnType<typeof getScenarioAudit>>, TError = ErrorType<unknown>>(
 scenarioId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getScenarioAudit>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetScenarioAuditQueryOptions(scenarioId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPromoteScenarioUrl = (scenarioId: string,) => {




  return `/api/scenarios/${scenarioId}/promote`
}

export const promoteScenario = async (scenarioId: string,
    scenarioPromotionInput: ScenarioPromotionInput, options?: Parameters<typeof customFetch>[1]): Promise<ScenarioPromotion> => {

  return customFetch<ScenarioPromotion>(getPromoteScenarioUrl(scenarioId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scenarioPromotionInput)
  }
);}





export const getPromoteScenarioMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof promoteScenario>>, TError,{scenarioId: string;data: BodyType<ScenarioPromotionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof promoteScenario>>, TError,{scenarioId: string;data: BodyType<ScenarioPromotionInput>}, TContext> => {

const mutationKey = ['promoteScenario'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof promoteScenario>>, {scenarioId: string;data: BodyType<ScenarioPromotionInput>}> = (props) => {
          const {scenarioId,data} = props ?? {};

          return  promoteScenario(scenarioId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PromoteScenarioMutationResult = NonNullable<Awaited<ReturnType<typeof promoteScenario>>>
    export type PromoteScenarioMutationBody = BodyType<ScenarioPromotionInput>
    export type PromoteScenarioMutationError = ErrorType<ErrorResponse>

    export const usePromoteScenario = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof promoteScenario>>, TError,{scenarioId: string;data: BodyType<ScenarioPromotionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof promoteScenario>>,
        TError,
        {scenarioId: string;data: BodyType<ScenarioPromotionInput>},
        TContext
      > => {
      return useMutation(getPromoteScenarioMutationOptions(options));
    }

